<div class="page-content bg-white">
  <!-- inner page banner -->
  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <div style="text-align: center;">
      <img class="logo" src="http://www.planificacion.gob.bo/assets/NUEVO_LOGO_MPD.png" alt="">
    </div>

    <!-- Career -->
    <div class="container">
      <div *ngIf="_auth" class="row">
        <div class="col-md-12">
          <dx-toolbar>
            <dxi-item location="center"
              widget="dxButton"
              locateInMenu="never">
              <div *dxTemplate>
                <div class='toolbar-label'>
                  <div class="h3">Inversión Pública en Cifras</div>
                </div>
              </div>
            </dxi-item>
            <dxi-item location="after"
              widget="dxMenu"
              locateInMenu="auto"
              [options]="selectBoxOptions">
          </dxi-item>
          </dx-toolbar>
        </div>
      </div>
      <br>
      <div class="row">
        <!-- Left part start -->
        <div *ngIf="_auth">
            <div style="display: flow-root;">
              <table style="width: 100px;margin: 0px;float: left;" *ngIf="buscarSw || buscarSwGeneral">
                <tr>
                  <td style="padding: 2px;">
                    <dx-button text="Página Principal"  (onClick)="paginaInicio()">
                    </dx-button>
                  </td>
                </tr>
              </table>
              <table style="width: 300px;margin: 0px;float: right;">
                <tr>
                  <td style="padding: 2px;">
                    <dx-button text="Proyectos SISIN" (onClick)="buscarProyectosGeneral()" [type]="boton1">
                    </dx-button>
                  </td>
                  <td style="padding: 2px;">
                    <dx-button text="Proyectos Gestión Vigente" (onClick)="buscarProyectos()" [type]="boton2">
                    </dx-button>
                  </td>
                </tr>
              </table>
            </div>
          <ng-container *ngIf="buscarSw">
            <div style="display: flow-root;">
              <table style="width: 700px;margin: 0px;float: left;">
                <tr>
                  <td style="padding: 2px;">
                    <dx-select-box [items]="gestiones" displayExpr="gestion"
                valueExpr="gestion"  (onValueChanged)="filtraGestiones($event)" [(value)]="gestion"
                        style="width: 90px;"
                ></dx-select-box>
                  <td style="padding: 2px;">
                    <dx-select-box [items]="tipoEntidades" displayExpr="tipo_entidad"
                valueExpr="orden_reporte"  (onValueChanged)="filtraEntidades($event)" [(value)]="tipoEntidad"
                        [searchEnabled]="true"
                        placeholder="Todos"
                        [showClearButton]="true"
                ></dx-select-box>
                  </td>
                  <td style="padding: 2px;">
                    <dx-select-box [items]="entidades" displayExpr="entidad"
                valueExpr="cod_entidad" [(value)]="entidad" [searchEnabled]="true" (onValueChanged)="filtrar()"
                placeholder="Todos"
                [showClearButton]="true"
                style="width: 400px;"
                ></dx-select-box>
                  </td>
                </tr>
              </table>


              <table style="width: 300px;margin: 0px;float: right;">
                <tr>
                  <td style="padding: 2px;">
                    <dx-text-box
                      placeholder="Buscar..."
                      showClearButton="true"
                      (onKeyUp)="buscarKey($event)"
                      [(value)]="buscarTxt">
                    </dx-text-box>
                  </td>
                  <td style="padding: 2px;">
                    <dx-button text="Buscar" (onClick)="filtrar()" type="success">
                      <div *dxTemplate="let data of 'content'">
                        <dx-load-indicator class='button-indicator'
                            [visible]="loadIndicatorVisible">
                        </dx-load-indicator>
                        <span class='dx-button-text'>Buscar</span>
                      </div>
                    </dx-button>
                  </td>
                </tr>
              </table>
            </div>
            <dx-data-grid
              [dataSource]="proyectos"
              [allowColumnReordering]="false"
              [rowAlternationEnabled]="true"
              [width]="'100%'"
              wordWrapEnabled="true"
              [showBorders]="true"
              [remoteOperations]="true">
              <dxi-column dataField="priorizado" caption="Pri."  [width]="40" [allowSorting]="false" cellTemplate="priTemplate" [allowFiltering]="false"></dxi-column>
              <div *dxTemplate="let data of 'priTemplate'" >
                <img src="assets/star.png" *ngIf="data.data.priorizado">
              </div>
              <dxi-column  dataField="sigla_entidad" caption="Entidad" dataType="string"  [width]="90" cellTemplate="cellEntidad"></dxi-column>
              <div *dxTemplate="let data of 'cellEntidad'" >
                <a routerLink=""  (click)="reporteModalConListaReportes(data.data,'3')">{{data.data.sigla_entidad}}</a>
              </div>
              <dxi-column dataField="codigo_sisin" caption="CODIGO SISIN" [width]="140" [allowFiltering]="false"></dxi-column>
              <dxi-column dataField="nombre_formal" caption="PROYECTO" dataType="string" cellTemplate="cellTemplate" ></dxi-column>
              <div *dxTemplate="let data of 'cellTemplate'" >
                <a routerLink="" (click)="open2(data.data.url_proyecto)">{{data.data.nombre_formal}}</a>
              </div>
              <dxi-column dataField="presupuesto" [width]="150" dataType="number" alignment="right" [allowFiltering]="false">
                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
              </dxi-column>
              <dxi-column dataField="reprogramado" [width]="150" dataType="number" alignment="right" [allowFiltering]="false">
                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
              </dxi-column>
              <dxi-column dataField="ejecutado" [width]="150" dataType="number" alignment="right" [allowFiltering]="false">
                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
              </dxi-column>
              <dxi-column dataField="porc_div" caption="%EJEC/PRESUP" [width]="130" dataType="number" alignment="right" [allowFiltering]="false"
              ></dxi-column>
              <dxi-column caption="" cellTemplate="cellAction" [width]="55">
              </dxi-column >
              <div *dxTemplate="let data of 'cellAction'" >
                <a routerLink="" class="btn btn-primary" (click)="reporteModalConListaReportes(data.data,'2')"><i class="fa fa-print"></i></a>
              </div>
              <dxo-remote-operations
                  [filtering]="true"
                  [paging]="true"
                  [sorting]="true">
              </dxo-remote-operations>
              <dxo-paging [pageSize]="15"></dxo-paging>
              <dxo-pager
            [showPageSizeSelector]="false"
            [allowedPageSizes]="false"
            infoText="Página #{0}. Total: {1} ({2} registros)"
            [showInfo]="true"></dxo-pager>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

          </dx-data-grid>



          </ng-container>
          <ng-container *ngIf="buscarSwGeneral">
            <div style="display: flow-root;">
              <table style="width: 700px;margin: 0px;float: left;">
                <tr>
                  <td style="padding: 2px;">
                    <dx-select-box [items]="departamentos" displayExpr="departamento"
                valueExpr="cod_departamento"  (onValueChanged)="filtraDepartamentos($event)" [(value)]="departamento"
                        style="width: 210px;"
                        placeholder="Todos los departamentos"
                        [showClearButton]="true"
                ></dx-select-box>
                </tr>
              </table>

              <table style="width: 300px;margin: 0px;float: right;">
                <tr>
                  <td style="padding: 2px;">
                    <dx-text-box
                      placeholder="Buscar..."
                      showClearButton="true"
                      (onKeyUp)="buscarKeyGeneral($event)"
                      [(value)]="buscarTxt">
                    </dx-text-box>
                  </td>
                  <td style="padding: 2px;">
                    <dx-button text="Buscar" (onClick)="filtrarGeneral()" type="success">
                      <div *dxTemplate="let data of 'content'">
                        <dx-load-indicator class='button-indicator'
                            [visible]="loadIndicatorVisible">
                        </dx-load-indicator>
                        <span class='dx-button-text'>Buscar</span>
                      </div>
                    </dx-button>
                  </td>
                </tr>
              </table>
            </div>
            <dx-data-grid
              [dataSource]="proyectosGeneral"
              [allowColumnReordering]="false"
              [rowAlternationEnabled]="true"
              [width]="'100%'"
              wordWrapEnabled="true"
              [showBorders]="true"
              [remoteOperations]="true">
              <dxi-column dataField="marca_prioridad" caption="Pri."  [width]="40" [allowSorting]="false" cellTemplate="priTemplate" [allowFiltering]="false"></dxi-column>
              <div *dxTemplate="let data of 'priTemplate'" >
                <img src="assets/star.png" *ngIf="data.data.marca_prioridad">
              </div>
              <dxi-column dataField="departamento" caption="DEPTO."  [width]="100" [allowFiltering]="false"></dxi-column>
              <dxi-column dataField="municipio" caption="Municipio"  [width]="120" ></dxi-column>
              <dxi-column dataField="abrev_entidad" caption="Entidad"  [width]="130" ></dxi-column>
              <dxi-column dataField="codigo_sisin_formato" caption="CODIGO SISIN" [width]="140" [allowFiltering]="false"></dxi-column>
              <dxi-column dataField="nombre_formal" caption="PROYECTO" dataType="string" cellTemplate="cellTemplate" ></dxi-column>
              <div *dxTemplate="let data of 'cellTemplate'" >
                <a routerLink="" (click)="open2(data.data.url_enlace)">{{data.data.nombre_formal}}</a>
              </div>
              <dxi-column dataField="fecha_inicio_estimada" caption="FECHA INICIO ESTIMADA" [width]="140" [allowFiltering]="false"></dxi-column>
              <dxi-column dataField="fecha_fin_estimada" caption="FECHA FIN ESTIMADA" [width]="140" [allowFiltering]="false"></dxi-column>
              <dxi-column dataField="sector_economico" caption="SECTOR ECONOMICO" [width]="130" ></dxi-column>
              <dxi-column caption="" cellTemplate="cellAction" [width]="55">
              </dxi-column >
              <div *dxTemplate="let data of 'cellAction'" >
                <a routerLink="" class="btn btn-primary" (click)="reporteModal(data.data)"><i class="fa fa-print"></i></a>
              </div>
              <dxo-remote-operations
                  [filtering]="true"
                  [paging]="true"
                  [sorting]="true">
              </dxo-remote-operations>
              <dxo-paging [pageSize]="15"></dxo-paging>
              <dxo-pager
            [showPageSizeSelector]="false"
            [allowedPageSizes]="false"
            infoText="Página #{0}. Total: {1} ({2} registros)"
            [showInfo]="true"></dxo-pager>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

          </dx-data-grid>
          </ng-container>

          <ng-container *ngIf="!buscarSw && !buscarSwGeneral">
            <dx-tabs
              [dataSource]="tabs"
              [scrollByContent]="true"
              [selectedIndex]="selectedIndex"
              [showNavButtons]="true"
              (onItemClick)="selectTab($event)">
            </dx-tabs>
            <div style="height: 10px;"></div>
          <ng-container *ngIf="selectedIndex==0">
            <div class="breadcrumb-row" style="background-color: white;padding: 0px;">
              <div class="container">
                <ul class="list-inline">
                  <li *ngFor="let item of breadcrumbs">
                    <ng-container *ngIf="item.active">
                      <span class="ribbon-active">
                      <a routerLink="" (click)="update(item)">
                        {{item.name}}
                      </a>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="!item.active">
                      <span class="ribbon">{{item.name}}</span>
                    </ng-container>
                  </li>
                </ul>
              </div>
            </div>
            <br>
            <report-charts [hidden]="hiddenReport" (loadData)="loadData($event)"></report-charts>
            <app-data-view *ngIf="showAppData" [hidden]="hiddenAppData" [type]="type" [urlData]="urlData" (loadData)="loadData2($event)"></app-data-view>
            <app-project-view *ngIf="showProjectData" [hidden]="hiddenProjectData" [urlData]="urlDataProject"></app-project-view>
          </ng-container>
          <ng-container *ngIf="selectedIndex==1">
            <externo-charts></externo-charts>
          </ng-container>
          </ng-container>

        </div>
        <div *ngIf="!_auth">
          <app-auth (auth)="auth($event)"></app-auth>
        </div>
      </div>
    </div>
  </div>
</div>

<dx-popup
  class="popup"
  (onHidden)="onHidden()"
  width="400px"
  height="400px"
  [showTitle]="true"
  title="Cambiar contraseña"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <form *ngIf="popupVisible" action="your-action" (submit)="onFormSubmit($event)">
      <div class="dx-fieldset">
        <div class="dx-field">
          <span>Contraseña:</span>
            <div>
                <dx-text-box
                    mode="password"
                    [(value)]="password">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="El campo contraseña es requerido"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
          </div>
          <div class="dx-field">
            <span>Nueva contraseña:</span>
              <div>
                  <dx-text-box
                      mode="password"
                      [(value)]="newPassword">
                      <dx-validator>
                          <dxi-validation-rule type="required" message="El campo nueva contraseña es requerido"></dxi-validation-rule>
                      </dx-validator>
                  </dx-text-box>
              </div>
          </div>
          <div class="dx-field">
            <span>Confirme la contraseña</span>
            <div>
                <dx-text-box mode="password">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="El campo Confirme contraseña es requerido"></dxi-validation-rule>
                        <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison"
                            message="Nueva contraseña y confirme contraseña no son iguales"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
        </div>
      </div>
      <div class="dx-fieldset">
          <dx-validation-summary id="summary"></dx-validation-summary>
          <div style="float: right;">
            <dx-button
            id="button"
            text="Cambiar"
            type="success"
            [useSubmitBehavior]="true">
        </dx-button>
          </div>

      </div>
    </form>
      </div>
</dx-popup>
<dx-load-panel
                        #loadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        message="Cargando..."
                        [(visible)]="loadingVisible"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true"
                        [closeOnOutsideClick]="false">
                      </dx-load-panel>
<dx-popup
        [width]="300"
        [height]="250"
        [showTitle]="false"
        fullScreen="true"
        [dragEnabled]="false"
        [closeOnOutsideClick]="true"
        [(visible)]="popupBuscarVisible">
        <div *dxTemplate="let data of 'content'">
          <div style="text-align: right;">
            <div style="float:left; font-size: 18px;font-weight: bold;line-height: 2;">

            </div>
            <dx-button
              id="button"
              icon="close"
              (onClick)="popupBuscarVisible=false;">
            </dx-button>
          </div>
          <iframe
          [src]="pdfSrc"
          style="width: 100%;height: 100%"
          type="text/html">
      </iframe>
        </div>
    </dx-popup>
    <dx-popup
    class="popup"
    width="400px"
    height="400px"
    [showTitle]="true"
    title="Reportes"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [(visible)]="reportePopupVisible">
    <div *dxTemplate="let data of 'content'">
      <div >
        <table class="table reporte">
          <tr>
            <th>Reporte</th>
            <th>PDF</th>
            <th>XLS</th>
          </tr>
          <tr *ngFor="let reporte of listaReportes">
            <td>
              <div *ngIf="reporte.cod_reporte_pdf; else templateName">
                {{reporte.pdf_descripcion}}
              </div>
              <ng-template #templateName>
                {{reporte.xls_descripcion}}
              </ng-template>
            </td>
            <td><a  routerLink="" (click)="open3(reporte, 'PDF')" *ngIf="reporte.cod_reporte_pdf"><img src="assets/pdf.jpg" alt="" width="30"></a></td>
            <td><a  routerLink="" (click)="open3(reporte, 'XLS')" *ngIf="reporte.cod_reporte_excel"><img src="assets/xls.jpg" alt="" width="30"></a></td>
          </tr>
        </table>
      </div>
    </div>
  </dx-popup>



// WEBPACK FOOTER //
// ./src/app/pages/report/report.component.html